import { Box, HStack, Text } from '@chakra-ui/react';
import { NovaIconButton } from 'components/ui/NovaIconButton';
import { ChevronLeftIcon, CloseIcon } from 'assets/icons/v2';
import { ModalHeaderProps } from 'components/common/Modal/CustomModal';
import React, { ReactElement } from 'react';
import { NovaIcon } from 'components/ui/novaIcon';
import { ModalSearchBar } from './ModalSearchBar';
import { useModalNavigation } from './ModalNavigationContext';

type Props = ModalHeaderProps & {
  shouldShowBackButton?: boolean;
  onSearch?: (search: string) => void;
  customBackFn?: () => void;
};

export const ModalSearchHeader = ({
  handleClose,
  title = 'Video einfügen',
  shouldShowBackButton,
  onSearch,
  customBackFn,
  ...props
}: Props): ReactElement => {
  const modalNavigation = useModalNavigation();
  const handleBack = (): void => {
    if (customBackFn) {
      customBackFn();
      return;
    }
    if (modalNavigation) {
      modalNavigation.goBack();
    }
  };
  return (
    <Box position="relative" p="25px" {...props}>
      <HStack justifyContent="space-between" width="100%">
        <HStack width="100%" gap="l" flexGrow={1} justifyContent="flex-start">
          <HStack gap="10px">
            {shouldShowBackButton ? (
              <NovaIconButton
                flexShrink={1}
                flexGrow={0}
                variant="primary"
                size="l"
                aria-label="Zurück"
                onClick={handleBack}
                color="text.secondary"
                icon={ChevronLeftIcon}
              />
            ) : null}
            <Text as="h2" textStyle="h3.medium" whiteSpace="nowrap" flexShrink={1}>
              {title}
            </Text>
          </HStack>
          <ModalSearchBar onSubmit={onSearch} />
        </HStack>

        <NovaIcon
          icon={CloseIcon}
          size="l"
          onClick={handleClose}
          cursor="pointer"
          color="text.secondary"
        />
      </HStack>
    </Box>
  );
};
